import React, { useEffect, useState } from 'react';

const BankListPrint = () => {
    const [transactions, setTransactions] = useState([]);

    useEffect(() => {
        const stored = localStorage.getItem('print_bank_list');
        if (stored) {
            const parsed = JSON.parse(stored);
            const allTxs = parsed.transactions || [];
            // Filter out non-deposit transactions (e.g., treasury_feed or expense)
            const depositTxs = allTxs.filter(tx => !tx.type || tx.type === 'deposit');
            setTransactions(depositTxs);
        }

        setTimeout(() => window.print(), 900);
    }, []);

    const totalAmount = transactions.reduce((acc, tx) => acc + parseFloat(tx.total_amount || 0), 0);
    const nonEspeceAmount = transactions
        .filter(tx => tx.payment_mode_name !== 'ESPECE')
        .reduce((acc, tx) => acc + parseFloat(tx.total_amount || 0), 0);
    const especeAmount = transactions
        .filter(tx => tx.payment_mode_name === 'ESPECE')
        .reduce((acc, tx) => acc + parseFloat(tx.total_amount || 0), 0);

    const totalTransactions = transactions.length;

    const formatDate = (d) => {
        if (!d) return '--';
        try { return new Date(d).toLocaleDateString('fr-MA'); } catch { return d; }
    };

    const fmt = (n) => Number(n).toLocaleString('fr-MA', { minimumFractionDigits: 2 });

    return (
        <div className="report-wrapper" dir="rtl">

            {/* ══ Header ══════════════════════════════════════════════════════ */}
            <div className="report-header">
                <div className="header-logo-side">
                    <img src="/logo.png" alt="شعار الجمعية" className="header-logo" />
                    <div>
                        <p className="assoc-name">جمعية تنمية النقل المدرسي</p>
                        <p className="assoc-sub">ولاد دحو</p>
                    </div>
                </div>
                <div className="header-title-side">
                    <h1 className="report-title">قائمة العمليات البنكية المودعة</h1>
                    <p className="report-print-date">تاريخ الطباعة: {new Date().toLocaleDateString('fr-MA')}</p>
                </div>
            </div>

            {/* ══ Main Table ══════════════════════════════════════════════════ */}
            <table className="main-table">
                <thead>
                    <tr>
                        <th className="col-num">#</th>
                        <th className="col-date">التاريخ</th>
                        <th className="col-number">رقم العملية</th>
                        <th className="col-owner">صاحب العملية</th>
                        <th className="col-bank">البنك / الحساب</th>
                        <th className="col-mode">الوسيلة</th>
                        <th className="col-amount">المبلغ الإجمالي</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.length === 0 ? (
                        <tr><td colSpan="7" className="empty-row">لا توجد بيانات</td></tr>
                    ) : (
                        transactions.map((tx, idx) => (
                            <tr key={tx.id} className={idx % 2 === 0 ? 'row-even' : 'row-odd'}>
                                <td className="td-center">{idx + 1}</td>
                                <td className="td-center">{tx.transaction_date}</td>
                                <td className="td-center receipt-num">{tx.transaction_number || `#TX-${tx.id}`}</td>
                                <td className="td-name">{tx.owner_name}</td>
                                <td>
                                    <div className="bank-info">
                                        <span className="bank-name">{tx.bank_name}</span>
                                        <span className="account-num">{tx.account_number}</span>
                                    </div>
                                </td>
                                <td className="td-center">
                                    <span className="td-mode">{tx.payment_mode_name || '--'}</span>
                                </td>
                                <td className="td-amount">{fmt(tx.total_amount)} &nbsp;د.م</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {/* ══ Summary Table ═══════════════════════════════════════════════ */}
            <div className="summary-wrapper">
                <table className="summary-table">
                    <thead>
                        <tr>
                            <th colSpan="2" className="summary-header">ملخص العمليات</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="sum-label">عدد العمليات البنكية</td>
                            <td className="sum-val">{totalTransactions} عملية</td>
                        </tr>
                        <tr>
                            <td className="sum-label">مجموع العمليات البنكية </td>
                            <td className="sum-val">{fmt(nonEspeceAmount)} د.م</td>
                        </tr>
                        <tr>
                            <td className="sum-label">مجموع العمليات نقداً </td>
                            <td className="sum-val">{fmt(especeAmount)} د.م</td>
                        </tr>
                        <tr className="sum-total-row">
                            <td className="sum-label">المجموع الكلي المودع</td>
                            <td className="sum-val sum-grand">{fmt(totalAmount)} د.م</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* ══ Footer ══════════════════════════════════════════════════════ */}
            <div className="report-footer">
                <div className="footer-sign">
                    <span>توقيع المحاسب</span>
                    <div className="sign-line" />
                </div>
                <div className="footer-sign">
                    <span>ختم الجمعية</span>
                    <div className="sign-line" />
                </div>
            </div>

            {/* ══ Styles ══════════════════════════════════════════════════════ */}
            <style dangerouslySetInnerHTML={{ __html: `
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');

                * { box-sizing: border-box; margin: 0; padding: 0; }

                body {
                    font-family: 'Cairo', sans-serif;
                    background: #fff;
                    color: #111;
                    direction: rtl;
                }

                .report-wrapper {
                    width: 210mm;
                    margin: 0 auto;
                    padding: 8mm 10mm;
                    direction: rtl;
                }

                /* ── Header ── */
                .report-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 2px solid #000;
                    padding-bottom: 8px;
                    margin-bottom: 10px;
                }
                .header-logo-side { display: flex; align-items: center; gap: 10px; }
                .header-logo { height: 55px; }
                .assoc-name { font-size: 13px; font-weight: 700; }
                .assoc-sub  { font-size: 11px; color: #555; }
                .header-title-side { text-align: left; }
                .report-title { font-size: 18px; font-weight: 700; }
                .report-print-date { font-size: 10px; color: #666; margin-top: 2px; }

                /* ── Main Table ── */
                .main-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 11px;
                    margin-bottom: 14px;
                }
                .main-table th {
                    background: #1e293b;
                    color: #fff;
                    padding: 6px 5px;
                    text-align: center;
                    border: 1px solid #000;
                    font-size: 11px;
                }
                .main-table td {
                    border: 1px solid #666;
                    padding: 4px 5px;
                    vertical-align: middle;
                }
                .row-even { background: #fff; }
                .row-odd  { background: #f8fafc; }

                .col-num     { width: 30px; }
                .col-date    { width: 80px; }
                .col-number  { width: 100px; }
                .col-owner   { width: 150px; }
                .col-bank    { width: auto; }
                .col-mode    { width: 80px; }
                .col-amount  { width: 100px; }

                .td-center  { text-align: center; }
                .td-name    { font-weight: 600; }
                .td-amount  { text-align: center; font-weight: 700; }
                .bank-info { display: flex; flex-direction: column; }
                .bank-name { font-weight: 700; color: #1e293b; }
                .account-num { font-size: 10px; color: #64748b; }
                .td-mode    { font-size: 10px; font-weight: 600; color: #334155; }
                .receipt-num { font-weight: 700; font-family: monospace; }
                .empty-row  { text-align: center; padding: 20px; color: #999; }

                /* ── Summary Table ── */
                .summary-wrapper {
                    display: flex;
                    justify-content: flex-end;
                    margin-bottom: 16px;
                }
                .summary-table {
                    width: 50%;
                    border-collapse: collapse;
                    font-size: 12px;
                }
                .summary-header {
                    background: #1e293b;
                    color: #fff;
                    text-align: center;
                    padding: 6px 10px;
                    border: 1px solid #000;
                    font-size: 12px;
                }
                .summary-table td {
                    border: 1px solid #888;
                    padding: 5px 10px;
                }
                .sum-label { text-align: right; font-weight: 600; background: #f1f5f9; width: 60%; }
                .sum-val   { text-align: center; font-weight: 700; }
                .sum-total-row td { background: #e2e8f0 !important; }
                .sum-grand { font-size: 14px; }

                /* ── Footer ── */
                .report-footer {
                    display: flex;
                    justify-content: space-around;
                    margin-top: 20px;
                    padding-top: 10px;
                    border-top: 1px solid #ccc;
                }
                .footer-sign { text-align: center; font-size: 12px; font-weight: 600; }
                .sign-line { border-top: 1px solid #000; width: 100px; margin: 30px auto 0; }

                /* ── Print ── */
                @media print {
                    @page { size: A4 portrait; margin: 8mm; }
                    body  { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                    .report-wrapper { width: 100%; padding: 0; }
                }
            `}} />
        </div>
    );
};

export default BankListPrint;
